<mat-card>
	<mat-card-title>Settings</mat-card-title>
	<hr />
	<mat-card-content class="card-content" fxLayoutGap="5px">
		<div fxFlex="100">
			<div class="demo-full-width mt-1">
				<mat-checkbox
					style="width: 100%;"
					name="showInstructorColum"
					(ngModelChange)="isNeedChange()"
					[(ngModel)]="payScale.isInstructorPayScale"
				>
					Show instructor columns
				</mat-checkbox>
			</div>
			<div class="demo-full-width mt-1">
				<mat-checkbox
					style="width: 100%;"
					name="globalSetting"
					(ngModelChange)="isNeedChange()"
					[(ngModel)]="payScale.isApRatingPayScale"
				>
					Use Global A&P bonus of {{ payScale.constantApBonus }}%
				</mat-checkbox>
			</div>
		</div>
	</mat-card-content>
</mat-card>
